import { NewDynamicTab } from "../../../components/Page";
import { JvvnlOverview } from "../../../config/DefaultDates";
import { JvvnlTitle } from "../Jvnnl_Dashboard";
import { JvvnlFeederDemand } from "./FeederDemand";

export function JvvnlOverviewTab() {
  return (
    <NewDynamicTab
      defaultDates={JvvnlOverview}
      header="Overview"
      showTabs={false}
      middleComponent={<JvvnlTitle />}
      tabs={{
        Overview: <JvvnlFeederDemand />,
      }}
    />
  );
}
